module.exports = __webpack_public_path__ + "static/story4-01-3815x1355-cb135fb91d3d0733402aa4a976c93355.jpg";